import { render, staticRenderFns } from "./referral-discount-alert.vue?vue&type=template&id=032d1314"
import script from "./referral-discount-alert.vue?vue&type=script&lang=js"
export * from "./referral-discount-alert.vue?vue&type=script&lang=js"
import style0 from "./referral-discount-alert.vue?vue&type=style&index=0&id=032d1314&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports